/*
  Powers sections/main-product.liquid.
  Everything here reads the real product/variant data Shopify renders into
  the <script type="application/json" id="ProductJson-{{ section.id }}">
  tag, so option buttons, price, gallery, and the add-to-cart button all stay
  in sync with actual Shopify variants instead of being static markup.
*/

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="ProductJson-"]').forEach(function (jsonEl) {
    var sectionId = jsonEl.id.replace('ProductJson-', '');
    var wrapper = jsonEl.closest('.shopify-section') || document;
    var product = JSON.parse(jsonEl.textContent);

    var variantIdInput = wrapper.querySelector('#ProductVariantId-' + sectionId);
    var priceWrap = wrapper.querySelector('#ProductPrice-' + sectionId);
    var addBtn = wrapper.querySelector('#AddToCart-' + sectionId);
    var addBtnText = addBtn ? addBtn.querySelector('[data-add-to-cart-text]') : null;
    var mainImage = wrapper.querySelector('#ProductMainImage-' + sectionId);
    var qtyInput = wrapper.querySelector('[data-qty-input]');
    var optionGroups = wrapper.querySelectorAll('.product-option-values');
    var thumbs = wrapper.querySelectorAll('[data-gallery-thumb]');
    var prevBtn = wrapper.querySelector('[data-gallery-prev]');
    var nextBtn = wrapper.querySelector('[data-gallery-next]');
    var form = wrapper.querySelector('#ProductForm-' + sectionId);
    var currentImageIndex = 0;

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function selectedOptions() {
      var selections = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.option-value.selected');
        selections.push(active ? active.getAttribute('data-option-value') : null);
      });
      return selections;
    }

    function findVariant() {
      var selections = selectedOptions();
      return product.variants.find(function (variant) {
        var opts = [variant.option1, variant.option2, variant.option3];
        return selections.every(function (val, i) {
          return val === null || opts[i] === val;
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant || !variantIdInput) return;

      variantIdInput.value = variant.id;

      if (priceWrap) {
        var html = '<span class="price-current">' + money(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="price-compare">' + money(variant.compare_at_price) + '</span>';
        }
        priceWrap.innerHTML = html;
      }

      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addBtnText) {
          addBtnText.textContent = variant.available
            ? addBtn.getAttribute('data-add-label')
            : addBtn.getAttribute('data-sold-out-label');
        }
        addBtn.removeAttribute('data-state');
      }
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.option-value').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.option-value').forEach(function (b) {
            b.classList.remove('selected');
          });
          btn.classList.add('selected');
          updateForVariant(findVariant());
        });
      });
    });

    if (qtyInput) {
      var minus = wrapper.querySelector('[data-qty-minus]');
      var plus = wrapper.querySelector('[data-qty-plus]');
      if (minus) {
        minus.addEventListener('click', function () {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        });
      }
    }

    if (thumbs.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          currentImageIndex = parseInt(thumb.getAttribute('data-index'), 10);
          if (mainImage) mainImage.src = thumb.getAttribute('data-image');
        });
      });
    }
    if (prevBtn && thumbs.length) {
      prevBtn.addEventListener('click', function () {
        currentImageIndex = (currentImageIndex - 1 + thumbs.length) % thumbs.length;
        thumbs[currentImageIndex].click();
      });
    }
    if (nextBtn && thumbs.length) {
      nextBtn.addEventListener('click', function () {
        currentImageIndex = (currentImageIndex + 1) % thumbs.length;
        thumbs[currentImageIndex].click();
      });
    }

    if (form && addBtn) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (addBtn.getAttribute('data-state') === 'in-cart') {
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
          return;
        }

        addBtn.disabled = true;
        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (err) { throw err; });
            return response.json();
          })
          .then(function () {
            return fetch('/cart.js').then(function (res) { return res.json(); });
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            if (addBtnText) addBtnText.textContent = addBtn.getAttribute('data-view-cart-label');
            addBtn.setAttribute('data-state', 'in-cart');
            addBtn.disabled = false;
          })
          .catch(function (err) {
            addBtn.disabled = false;
            if (addBtnText && err && err.description) {
              addBtnText.textContent = err.description;
            }
          });
      });
    }
  });
});
